'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { BookmarkFilledIcon, BookmarkIcon } from '@shared/ui-components/svgs';
import { GTM_ACTION_CLICK, GTM_EVENT_NAME_INTERNAL_LINK_CLICK, GTM_EVENT_USER_INTERACTIONS } from '@shared/utils/constants/gtm';
import { useFormatTranslationString } from '@shared/utils/helpers/format-translation-string';
import { sendGtmEvent } from '@shared/utils/helpers/send-gtm-event';
import { deleteBookmarks } from '../../utils/data/delete-bookmarks';
import { postBookmarks } from '../../utils/data/post-bookmarks';
import { useAddDefaultErrorToast } from '../../utils/hooks/use-add-default-error-toast';
import { useMutationHandler } from '../../utils/hooks/use-mutation-handler';
import { Button } from '../button/button';
import { useUserContext } from '../providers/user-context';
import { type BookmarkButtonCmsContent } from './get-bookmark-button-cms-content';
import { getContentCategory } from './get-content-category-label';
type BookmarkButtonClientProps = {
  cmsContent: BookmarkButtonCmsContent;
  contentType: null | number | undefined;
  initialIsBookmarked: boolean;
  learningMaterialId: null | string | undefined;
};
export const BookmarkButtonClient = t0 => {
  const $ = _c(22);
  const {
    cmsContent,
    contentType,
    initialIsBookmarked,
    learningMaterialId
  } = t0;
  const formatTranslationString = useFormatTranslationString();
  const {
    status
  } = useUserContext();
  const [isBookmarked, setIsBookmarked] = useState(initialIsBookmarked);
  const addErrorToast = useAddDefaultErrorToast();
  const isAuthenticated = status === "authenticated";
  let t1;
  let t2;
  if ($[0] !== initialIsBookmarked) {
    t1 = () => {
      setIsBookmarked(initialIsBookmarked);
    };
    t2 = [initialIsBookmarked];
    $[0] = initialIsBookmarked;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const contentTypeLabel = getContentCategory({
    contentType,
    labels: cmsContent.contentCategoryLabels
  });
  let t3;
  if ($[3] !== addErrorToast) {
    t3 = () => {
      addErrorToast();
      setIsBookmarked(false);
    };
    $[3] = addErrorToast;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    isMutationPending: isAddBookmarkPending,
    mutate: addBookmark
  } = useMutationHandler({
    mutationFunction: postBookmarks,
    onFailure: t3,
    scrollToTop: false,
    successMessage: formatTranslationString(cmsContent.addBookmarkSuccessMessage, {
      contentType: contentTypeLabel
    })
  });
  const t4 = deleteBookmarks;
  let t5;
  if ($[5] !== addErrorToast) {
    t5 = () => {
      addErrorToast();
      setIsBookmarked(false);
    };
    $[5] = addErrorToast;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = false;
  const t7 = formatTranslationString(cmsContent.removeBookmarkSuccessMessage, {
    contentType: contentTypeLabel
  });
  let t8;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t7) {
    t8 = {
      mutationFunction: t4,
      onFailure: t5,
      scrollToTop: t6,
      successMessage: t7
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const {
    isMutationPending: isDeletePending,
    mutate: deleteBookmark
  } = useMutationHandler(t8);
  let t9;
  if ($[11] !== addBookmark || $[12] !== deleteBookmark || $[13] !== isBookmarked || $[14] !== learningMaterialId) {
    t9 = () => {
      setIsBookmarked(!isBookmarked);
      if (isBookmarked) {
        deleteBookmark({
          bookmarkId: learningMaterialId
        });
      } else {
        addBookmark({
          learningMaterialId
        });
        sendGtmEvent({
          action: GTM_ACTION_CLICK,
          event: GTM_EVENT_USER_INTERACTIONS,
          eventName: GTM_EVENT_NAME_INTERNAL_LINK_CLICK,
          label: "saved_for_later"
        });
      }
    };
    $[11] = addBookmark;
    $[12] = deleteBookmark;
    $[13] = isBookmarked;
    $[14] = learningMaterialId;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleBookmarkToggle = t9;
  if (!isAuthenticated) {
    return null;
  }
  const t10 = isBookmarked ? cmsContent.removeBookmarkAriaLabel : cmsContent.addBookmarkAriaLabel;
  const t11 = isAddBookmarkPending || isDeletePending;
  const t12 = isBookmarked ? BookmarkFilledIcon : BookmarkIcon;
  let t13;
  if ($[16] !== handleBookmarkToggle || $[17] !== isBookmarked || $[18] !== t10 || $[19] !== t11 || $[20] !== t12) {
    t13 = <Button aria-label={t10} aria-pressed={isBookmarked} disabled={t11} Icon={t12} onClick={handleBookmarkToggle} />;
    $[16] = handleBookmarkToggle;
    $[17] = isBookmarked;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};